//#region imports
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { formatNumber, shouldHidePost, debounce } from "../lib/helper";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Dropdown as StrapDropdown,
} from "reactstrap";
import {
  Dropdown,
  Loading,
  Valert,
  Highlighted,
  Vmodal,
  NoDataAlert,
  SearchIcon,
} from "../components";
import { getLoggedInUser } from "../services/AuthenticationService";
import moment from "moment";
import { Row, Col } from "reactstrap";
import forumActions from "../actions/forumActions";
import { loginRequired } from "../services/UserService";
import InfiniteScroll from "react-infinite-scroll-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { USER_LANG } from "../actions/constant";
//#endregion

const ForumItem = ({
  data,
  likedAct,
  selectForEdit,
  forumFiltersForm,
  checkStatusForRedirect,
  userId,
  t,
}) => {
  return (
    data &&
    (!data.draft || (data.draft && data.publish_status === "republishing")) &&
    data.publish_status !== "irelevant" &&
    !shouldHidePost(data) && (
      <div className="forumItem">
        <Row
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 5px 0 5px",
          }}
        >
          <div className="idLink">
            <div
              className="checkmarkContainer"
              onClick={() => selectForEdit(data._id, "multiple")}
            >
              <input
                type="checkbox"
                checked={data.selected ? "checked" : ""}
                readOnly={true}
              />
              <span className="checkmark" />
            </div>
            <a
              href={
                userId && userId._id === data.user_id
                  ? `/forum/me`
                  : `/forum/${data.user_id}`
              }
            >
              {data.user_id}
            </a>
          </div>
          <div className="dateTime">
            {data.date
              ? moment.unix(data.date).format("DD MMM YYYY, hh:mma")
              : moment(data.created_at).format("DD MMM YYYY, hh:mma")}
          </div>
          <div style={{ marginRight: "25px" }}>
            <Row>
              <div className="relevant" style={{ marginRight: "5px" }}>
                {t("forum.RELAVENT_TEXT")}
              </div>
              <div
                className="vote yesVote"
                onClick={(e) => likedAct(data._id, true)}
                style={{ width: "63px" }}
              >
                <i className="fa fa-check-circle" />
                <div style={{ display: "inline", position: "relative" }}>
                  {formatNumber(data.relevant.up)}
                </div>
              </div>
              <div
                className="vote noVote"
                onClick={(e) => likedAct(data._id, false)}
                style={{ width: "43px" }}
              >
                <i className="fa fa-times-circle" />
                <div style={{ display: "inline", position: "relative" }}>
                  {formatNumber(data.relevant.down)}
                </div>
              </div>
            </Row>
          </div>
        </Row>
        <p 
        // style={{ whiteSpace: "pre-wrap" }}
        >
          <span style={{ color: "red" }}>
            {data.publish_status === "republished" ||
            data.publish_status_draft === "republished"
              ? t("forum.EDITED_TEXT")
              : ""}
          </span>
          <Highlighted
            text={data.body}
            highlight={
              forumFiltersForm && forumFiltersForm.search
                ? forumFiltersForm.search
                : ""
            }
          />
        </p>
        <div>
          {data.related &&
            data.related.map((item) => {
              return (
                <a
                  className="relatedPosts"
                  onClick={() => checkStatusForRedirect(item)}
                >
                  {item}
                </a>
              );
            })}
        </div>
      </div>
    )
  );
};

class Forum extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      sortDropDown: false,
      languageDropDown: false,
      searchTerm: "",
      uiActive: { sortBy: null },
    };
    this.checkStatusForRedirect = this.checkStatusForRedirect.bind(this);
    this.redirectLink = "";
    this.debounceTimeout = null;
  }
  componentDidUpdate(prevProps) {
    const { forumFiltersForm } = this.props;
    const { uiActive } = this.state;
    // Clear the temporary highlight once Redux equals our pending choice
    if (uiActive.sortBy && forumFiltersForm.sortBy === uiActive.sortBy) {
      this.setState({ uiActive: { ...uiActive, sortBy: null } });
    }

    // NEW: clear pending lang once Redux matches (including null)
    if (
      Object.prototype.hasOwnProperty.call(uiActive, "lang") &&
      ((uiActive.lang == null && forumFiltersForm.lang == null) ||
        forumFiltersForm.lang === uiActive.lang)
    ) {
      const next = { ...uiActive };
      delete next.lang; // remove the key so we fall back to Redux thereafter
      this.setState({ uiActive: next });
    }
  }


  async componentDidMount() {
    loginRequired();
    this.userId = await getLoggedInUser();
    this.props.forumInitialization();
  }

  async checkStatusForRedirect(item) {
    this.redirectLink = item;
    await this.props.forumSinglInitialization(this.redirectLink);
    this.redirectToLink();
  }

  redirectToLink() {
    if (this.props.singlePostItem) {
      const { publish_status } = this.props.singlePostItem;
      if (publish_status === "irelevant") {
        this.irrelevantPost.changeStatus();
      } else {
        window.location.href = `/forum/post/${this.redirectLink}`;
      }
    }
  }
  fetchMoreData = () => {
    let nextPage = this.props.postsList.current_page + 1;
    this.props.forumLoadMore(
      this.props.forumFiltersForm.symptom,
      this.props.forumFiltersForm.sortBy,
      this.props.forumFiltersForm.search,
      undefined,
      0,
      this.props.forumFiltersForm.lang,
      nextPage
    );
  };

  handleSearchChange = (e) => {
    const { value } = e.target;
    const { forumFiltersForm, onSearchPosts } = this.props;

    this.setState({ searchTerm: value });

    // Clear the previous timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Set a new timeout for 1 second
    this.debounceTimeout = setTimeout(() => {
      // userId=undefined, draft=0
      onSearchPosts(value, forumFiltersForm, undefined, 0);
    }, 1000);
  };

  scrollToTop() {
    this.myRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }

  render() {
    var {
      symptomsList,
      postsList,
      selectedPosts,
      onChangeFilters,
      forumFiltersForm,
      likedAct,
      relevantFailed,
      changeReduxState,
      isLoading,
      selectForEdit,
      doArchive,
      langList,
      name,
      value,
      onSearchPosts,
      t,
    } = this.props;
    let selectedItems = [];
    let archivedItems = [];
    if (selectedPosts.length > 0) {
      selectedItems = selectedPosts;
      archivedItems = selectedItems;
      selectedItems = selectedItems.map((item) => item._id);
    }
    return (
      <div className="vPage mealPlannerPage flex">
        <Loading isLoading={isLoading} />
        <Valert
          display={relevantFailed}
          title={t("forum.RELEVANT_FAILED_TITLE")}
          question={t("forum.RELEVANT_FAILED_MESSAGE")}
          positiveAction={() => {
            setTimeout(() => {
              changeReduxState("relevantFailed", false);
            }, 200);
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          title={t("forum.IRRELEVANT_POST_DELETED_TITLE")}
          question={t("forum.IRRELEVANT_POST_DELETED_TEXT")}
          onRef={(ref) => (this.irrelevantPost = ref)}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            return true;
          }}
          readOnly={true}
        />
        <Vmodal
          displayStatus={this.props.saveSuccess}
          data={
            <div>
              <h4>{t("forum.ARCHIVED_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("forum.ARCHIVED_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            this.props.clearForum();
            window.location.href = `/forum/archive`;
          }}
          timedClose={2000}
        />
        <Row style={{ alignItems: "center" }}>
          <Col>
            <div style={{ width: "84%" }}>
              <Dropdown
                name="symptom"
                options={[
                  {
                    value: "blank",
                    label: this.props.t("forum.SYMPTOMS_LIST_LABEL"),
                  },
                  {
                    value: "",
                    label: this.props.t("forum.ALL_PLACEHOLDER"),
                  },
                  ...symptomsList,
                ]}
                meta={{}}
                input={{
                  onChange: (e) => {
                    this.setState({ searchTerm: "" });
                    // userId=undefined, draft=0 (Forum requires non-draft only)
                    onChangeFilters(e, forumFiltersForm, undefined, 0);
                    this.scrollToTop();
                  },
                  name: "symptom",
                  value: forumFiltersForm.symptom,
                }}
              />
            </div>
          </Col>
          <Col>
            <div
              className="inputWithIcon"
              style={{
                width: "84%",
                marginLeft: "-40px",
                position: "relative",
              }}
            >
              <Input
                type="search"
                placeholder={this.props.t("forum.SEARCH_KEYWORD_LABEL")}
                onChange={this.handleSearchChange}
                name="search"
                autoComplete="off"
                value={this.state.searchTerm || ""}
              />
              {/* <i
                className="fa fa-search"
                style={{
                  cursor: "default",
                  fontSize: "1rem",
                  marginRight: 9,
                  marginTop: 3,
                }}
              /> */}
              <FontAwesomeIcon
                className="fa fa-search"
                icon={faMagnifyingGlass}
                style={{
                  cursor: "default",
                  fontSize: "1rem",
                  marginRight: 9,
                  marginTop: 3,
                }}
              />
            </div>
          </Col>

          <Row>
            <div
              style={{
                cursor: "pointer",
              }}
            >
              <StrapDropdown
                isOpen={this.state.sortDropDown}
                toggle={() => {
                  this.setState({
                    languageDropDown: false,
                    sortDropDown: !this.state.sortDropDown,
                  });
                }}
                direction="right"
              >
                <DropdownToggle data-toggle="dropdown" tag="span">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1.4em"
                    viewBox="0 0 576 512"
                    style={{ marginLeft: "-35px" }}
                  >
                    <path
                      d="M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 464c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H304z"
                      fill="#007bff"
                    />
                  </svg>
                </DropdownToggle>
                <DropdownMenu>
                  <p
                    className="form-control"
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      marginTop: "-2px",
                      marginBottom: "2px",
                    }}
                  >
                    {this.props.t("forum.SORTBY_DROPDOWN_OPTION")}
                  </p>
                  {[
                    {
                      value: "Most Recent",
                      label: this.props.t("forum.MOST_RECENT_DROPDOWN_OPTION"),
                    },
                    {
                      value: "relevancy",
                      label: this.props.t("forum.RELEVANCE_DROPDOWN_OPTION"),
                    },
                  ].map((option, i) => {
                    return (
                      <DropdownItem
                        style={{ height: "1.7rem" }}
                        className="form-control"
                        key={i}
                        value={option.value}
                        active={(this.state.uiActive.sortBy || forumFiltersForm.sortBy) === option.value}
                        onMouseDown={() =>
                          this.setState((s) => ({ uiActive: { ...s.uiActive, sortBy: option.value } }))
                        }
                        onClick={() => {
                          onChangeFilters(
                            { target: { name: "sortBy", value: option.value } },
                            forumFiltersForm,
                            undefined,
                            0
                          );
                          this.scrollToTop();
                        }}
                      >
                        {option.label}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </StrapDropdown>
            </div>

            <div
              style={{
                marginRight: "15px",
                cursor: "pointer",
              }}
            >
              <StrapDropdown
                isOpen={this.state.languageDropDown}
                toggle={() => {
                  this.setState({
                    languageDropDown: !this.state.languageDropDown,
                    sortDropDown: false,
                  });
                }}
              >
                <DropdownToggle data-toggle="dropdown" tag="span">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1.8em"
                    viewBox="0 0 640 512"
                    style={{ marginLeft: "10px" }}
                  >
                    <path
                      d="M304 96V416H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H304zm32 0H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H336V96zm304 32c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128zM174.9 170.1C172.4 164 166.5 160 160 160s-12.4 4-14.9 10.1l-64 160c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l8.8-21.9h80.7l8.8 21.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-64-160zm-14.9 49L187.6 288H132.4L160 219.1zM496 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 41.2l-.2 .6c-8.2 22.6-21.4 42.9-38.2 59.4l-.8-.8-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.9 20.9c-5 3.2-10.1 6.2-15.5 8.8l-17.3 8.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l17.3-8.6c9.1-4.6 17.8-9.8 26-15.7c5.9 4.4 12.1 8.6 18.4 12.4l18.9 11.3c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-18.9-11.3c-3.4-2-6.7-4.1-9.9-6.4c19.1-19.4 34.1-42.9 43.6-69l4.2-11.6H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H544 496V176z"
                      fill="#007bff"
                    />
                  </svg>
                </DropdownToggle>
                <DropdownMenu>
                  {/* “All” option first */}
                  <DropdownItem
                    style={{ height: "1.7rem" }}
                    className="form-control"
                    value={null}
                    active={Object.prototype.hasOwnProperty.call(this.state.uiActive, "lang")
                      ? this.state.uiActive.lang == null
                      : forumFiltersForm.lang == null}
                    onMouseDown={() =>
                      this.setState((s) => ({ uiActive: { ...s.uiActive, lang: null } }))
                    }
                    onClick={() => {
                      onChangeFilters(
                        { target: { name: "lang", value: null } },
                        forumFiltersForm,
                        undefined,
                        0
                      );
                      this.scrollToTop();
                    }}
                  >
                    {this.props.t("forum.ALL_PLACEHOLDER")}
                  </DropdownItem>
                  {/* Keep For Future Use -- Dynamic Language Dropdown based on Backend API */}
                  {/* {langList &&
                    langList.map((option, i) => {
                      return (
                        <DropdownItem
                          style={{ height: "1.7rem" }}
                          className="form-control"
                          key={i}
                          value={option.value}
                          active={forumFiltersForm.lang === option.value}
                          onClick={() => {
                            onChangeFilters(
                              { target: { name: "lang", value: option.value } },
                              forumFiltersForm,
                              undefined,
                              0
                            );
                            this.scrollToTop();
                          }}
                        >
                          {option.label}
                        </DropdownItem>
                      );
                    })} */}


                  {/* All languages directly from USER_LANG */}
                  {USER_LANG.map((opt) => (
                    <DropdownItem
                      key={opt.value}
                      className="form-control"
                      active={Object.prototype.hasOwnProperty.call(this.state.uiActive, "lang")
                        ? this.state.uiActive.lang === opt.value
                        : forumFiltersForm.lang === opt.value}
                      onMouseDown={() =>
                        this.setState((s) => ({ uiActive: { ...s.uiActive, lang: opt.value } }))
                      }
                      onClick={() => {
                        onChangeFilters(
                          { target: { name: "lang", value: opt.value } },
                          forumFiltersForm,
                          undefined,
                          0
                        );
                        this.scrollToTop();
                      }}
                    >
                      {opt.label}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </StrapDropdown>
            </div>
          </Row>
        </Row>
        <div
          id="scrollableDiv"
          className="grayList forumGrid"
          style={{ flex: "1 1 0" }}
          ref={this.myRef}
        >
          {/* When there's at list one post in the response API */}
          {postsList.data && postsList.data.length > 0 ? (
            <InfiniteScroll
              dataLength={postsList.data.length}
              next={this.fetchMoreData}
              hasMore={postsList.next_page_url}
              loader={
                <h4
                  style={{
                    fontFamily: "Calibri, sans-serif",
                    fontSize: "14px",
                    color: "#007bff",
                    marginLeft: "44%",
                  }}
                >
                  <b className="loading">{t("forum.LOADING_TEXT")}</b>
                </h4>
              }
              scrollableTarget="scrollableDiv"
              endMessage={
                postsList.data.length > 0 ? (
                  <p
                    style={{
                      fontFamily: "Calibri, sans-serif",
                      textAlign: "center",
                      fontSize: "14px",
                      color: "#007bff",
                    }}
                  >
                    <b>{t("forum.END_OF_LIST_TEXT")}</b>
                  </p>
                ) : null
              }
            >
              {postsList.data.map((item, index) => {
                return (
                  <ForumItem
                    userId={this.userId}
                    data={item}
                    key={item._id + index}
                    checkStatusForRedirect={this.checkStatusForRedirect}
                    likedAct={likedAct}
                    selectForEdit={selectForEdit}
                    forumFiltersForm={forumFiltersForm}
                    t={this.props.t}
                  />
                );
              })}
            </InfiniteScroll>
          ) : (
            !isLoading && (
              <div>
                {/* When there's no posts in the response API AND keyword param is not blank*/}
                { (forumFiltersForm.search && forumFiltersForm.search.trim() !== "") ? (
                  <NoDataAlert
                    color="#656565"
                    text={t("general.NO_MATCH_FOUND")}
                    bg="rgb(249, 250, 251)"
                    pt={5}
                    noBorder
                  />
                ) : (
                  <NoDataAlert
                    color="#656565"
                    text={t("recipe.NO_COMMUNITY_POST_DATA_TEXT")}
                    bg="rgb(249, 250, 251)"
                    mr={-2}
                    noBorder
                  />
                )}
              </div>
            )
          )}
        </div>
        <Row>
          <Col>
            <button
              className="btn btn-primary btnWide"
              onClick={() => {
                window.linksToNewPostItems = selectedItems;
                sessionStorage.setItem("linksToNewPostItems", selectedItems);
                window.linksToNewPostSymptom = this.props.symptomCat;
                sessionStorage.setItem(
                  "linksToNewPostSymptom",
                  this.props.symptomCat
                );
                window.location.href = "/forum/me";
              }}
            >
              {selectedItems.length > 0
                ? t("forum.CREATE_POST_WITH_LINK_BUTTON")
                : t("forum.MY_POSTS_TITLE")}
            </button>
          </Col>
          <Col>
            <button
              disabled={selectedItems.length <= 0}
              className="btn btn-primary btnWide"
              onClick={() => {
                doArchive(archivedItems);
              }}
            >
              {this.props.t("forum.ARCHIVE_TITLE")}
            </button>
          </Col>
        </Row>
      </div>
    );
  }
}
//#region exports

const mapStateToProps = (state) => ({
  ...state.forumReducer,
});
Forum = translate("translations")(Forum);

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...forumActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Forum);



// WEBPACK FOOTER //
// ./src/pages/Forum.js